import {
  brand,
  navLinks,
  channels,
  hotRank,
  headFeature,
  forumPosts,
  scenes,
  comments,
  tags,
  tools,
} from "@/mocks/homeData";

export default function Home() {
  const today = "2026.09.05";

  return (
    <div className="min-h-screen bg-[#FBF7EF] text-stone-800 font-sans">
      {/* ===== Header ===== */}
      <header className="sticky top-0 z-50 bg-[#FBF7EF]/90 backdrop-blur border-b border-orange-100/80">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-orange-500 text-lg font-bold text-white">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <h1 className="text-lg font-bold tracking-tight text-stone-900">{brand}</h1>
              <span className="text-[11px] text-stone-400">网友讨论 · 评论区 · 热议广场</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm text-stone-600 transition hover:bg-orange-100 hover:text-orange-700 whitespace-nowrap"
              >
                <i className={`${l.icon} text-base`}></i>
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#topics"
              aria-label="搜索话题"
              className="hidden h-9 w-9 items-center justify-center rounded-lg text-stone-500 transition hover:bg-orange-100 hover:text-orange-700 sm:flex"
            >
              <i className="ri-search-line text-lg"></i>
            </a>
            <a
              href="#hot"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-orange-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-orange-600"
            >
              <i className="ri-quill-pen-line text-base"></i>
              <span className="hidden sm:inline">参与热议</span>
              <span className="sm:hidden">发帖</span>
            </a>
          </div>
        </div>

        {/* mobile nav */}
        <div className="flex items-center gap-1 overflow-x-auto border-t border-orange-100/70 px-2 py-2 md:hidden">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="flex items-center gap-1 whitespace-nowrap rounded-full bg-white px-3 py-1.5 text-xs text-stone-600"
            >
              <i className={`${l.icon} text-sm`}></i>
              {l.label}
            </a>
          ))}
        </div>
      </header>

      <main id="top">
        {/* ===== Intro band ===== */}
        <section className="mx-auto max-w-7xl px-4 pt-8 md:px-6 md:pt-12">
          <div className="flex flex-col gap-1.5">
            <div className="flex items-center gap-2 text-sm text-stone-500">
              <span className="rounded-full bg-orange-100 px-2.5 py-0.5 text-xs font-medium text-orange-700">今日热聊中</span>
              <span>{today} · 网友讨论与评论区已实时更新</span>
            </div>
            <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
              <div>
                <h2 className="text-2xl font-bold tracking-tight text-stone-900 md:text-3xl">
                  吃瓜群众集合，最新话题热议一网打尽
                </h2>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-stone-500 md:text-base">
                  直达网友讨论现场与评论区热评，围观今日话题热议，论坛帖子与补档细节都在这里，互动不停。
                </p>
              </div>
              <div className="flex items-center gap-3 text-xs text-stone-400">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line text-sm text-orange-500"></i> 在线 8.6w
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line text-sm text-orange-500"></i> 今日新帖 312
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* ===== First screen: channel entry cards ===== */}
        <section className="mx-auto max-w-7xl px-4 py-6 md:px-6 md:py-8">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {channels.map((c) => (
              <a
                key={c.title}
                href={c.accent ? "#tools" : c.title === "今日热议" ? "#hot" : "#forum"}
                className={`group flex flex-col justify-between rounded-lg border p-5 transition hover:-translate-y-0.5 ${
                  c.accent
                    ? "border-orange-200 bg-orange-500 text-white"
                    : "border-orange-100 bg-white hover:border-orange-300"
                }`}
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-lg text-2xl ${
                      c.accent ? "bg-white/20 text-white" : "bg-orange-100 text-orange-600"
                    }`}
                  >
                    <i className={c.icon}></i>
                  </span>
                  <span
                    className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${
                      c.accent ? "bg-white/20 text-white" : "bg-orange-50 text-orange-600"
                    }`}
                  >
                    {c.stat}
                  </span>
                </div>
                <div className="mt-4">
                  <h3 className={`text-lg font-semibold ${c.accent ? "text-white" : "text-stone-900"}`}>{c.title}</h3>
                  <p className={`mt-1 text-sm leading-relaxed ${c.accent ? "text-orange-50" : "text-stone-500"}`}>
                    {c.desc}
                  </p>
                </div>
                <span
                  className={`mt-4 inline-flex items-center gap-1 text-sm font-medium ${
                    c.accent ? "text-white" : "text-orange-600 group-hover:gap-2"
                  } transition-all`}
                >
                  进入{` ${c.title === "客户端与插件" ? "下载" : "查看"}`}
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </a>
            ))}
          </div>
        </section>

        {/* ===== Head feature ===== */}
        <section className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex flex-col overflow-hidden rounded-lg border border-orange-100 bg-white lg:flex-row">
            <div className="relative lg:w-3/5">
              <div className="relative h-56 w-full sm:h-72 lg:h-full lg:min-h-[360px]">
                <img
                  src={headFeature.img}
                  alt="本期头版话题 直播名场面时间线 21吃瓜"
                  title={`${brand} 本期头版 直播名场面复盘`}
                  className="absolute inset-0 h-full w-full object-cover object-top"
                />
              </div>
            </div>
            <div className="flex flex-1 flex-col justify-center p-6 md:p-10">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-orange-100 px-3 py-1 text-xs font-medium text-orange-700">
                <i className="ri-fire-fill text-sm"></i>
                {headFeature.tag}
              </span>
              <h3 className="mt-4 text-xl font-bold leading-snug text-stone-900 md:text-2xl">{headFeature.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-stone-500 md:text-base">{headFeature.summary}</p>
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <a
                  href="#comments"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-orange-500 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-orange-600"
                >
                  <i className="ri-chat-3-line text-base"></i> 去评论区聊聊
                </a>
                <span className="text-sm text-stone-400">{headFeature.views}</span>
              </div>
            </div>
          </div>
        </section>

        {/* ===== Hot rank + comments ===== */}
        <section id="hot" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-8 md:px-6 md:py-10">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
            {/* hot rank */}
            <div className="lg:col-span-3">
              <div className="mb-4 flex items-center justify-between">
                <h4 className="flex items-center gap-2 text-lg font-bold text-stone-900">
                  <i className="ri-fire-fill text-orange-500"></i> 今日热议榜
                </h4>
                <a href="#hot" className="text-sm text-orange-600 hover:text-orange-700">
                  看全部
                </a>
              </div>
              <div className="divide-y divide-orange-100 rounded-lg border border-orange-100 bg-white">
                {hotRank.map((item) => (
                  <a key={item.id} href="#hot" className="group flex gap-4 p-4 transition hover:bg-orange-50 md:p-5">
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-base font-bold ${
                        item.id <= 3 ? "bg-orange-500 text-white" : "bg-orange-100 text-orange-600"
                      }`}
                    >
                      {item.id}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-start justify-between gap-3">
                        <h5 className="text-sm font-semibold leading-snug text-stone-800 group-hover:text-orange-700 md:text-[15px]">
                          {item.title}
                        </h5>
                        <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-medium text-orange-500">
                          <i className="ri-fire-line text-sm"></i>
                          {item.heat}
                        </span>
                      </div>
                      <div className="mt-1.5 flex flex-wrap items-center gap-2">
                        <p className="text-sm leading-relaxed text-stone-500">{item.summary}</p>
                      </div>
                      <span className="mt-2 inline-flex rounded-full bg-orange-50 px-2 py-0.5 text-[11px] text-orange-600">
                        {item.tag}
                      </span>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* comments */}
            <div id="comments" className="scroll-mt-24 lg:col-span-2">
              <div className="mb-4 flex items-center justify-between">
                <h4 className="flex items-center gap-2 text-lg font-bold text-stone-900">
                  <i className="ri-chat-3-fill text-orange-500"></i> 评论区神评
                </h4>
                <a href="#comments" className="text-sm text-orange-600 hover:text-orange-700">
                  热评更多
                </a>
              </div>
              <div className="flex flex-col gap-4">
                {comments.map((c) => (
                  <div key={c.name} className="rounded-lg border border-orange-100 bg-white p-5">
                    <div className="flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-orange-100 text-sm font-semibold text-orange-700">
                        {c.name.slice(0, 1)}
                      </span>
                      <div className="min-w-0">
                        <p className="text-sm font-semibold text-stone-800">{c.name}</p>
                        <p className="truncate text-xs text-stone-400">{c.source}</p>
                      </div>
                      {c.hot && (
                        <span className="ml-auto flex items-center gap-1 rounded-full bg-orange-100 px-2 py-0.5 text-[11px] font-medium text-orange-600">
                          <i className="ri-fire-fill text-xs"></i> 爆
                        </span>
                      )}
                    </div>
                    <p className="mt-3 text-sm leading-relaxed text-stone-600">{c.text}</p>
                    <div className="mt-3 flex items-center justify-between">
                      <span className="flex items-center gap-1 text-xs text-orange-500">
                        <i className="ri-thumb-up-line text-sm"></i> {c.likes.replace("点赞 ", "")}
                      </span>
                      <a href="#comments" className="text-xs text-stone-400 hover:text-orange-600">
                        回复本楼
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ===== Forum posts ===== */}
        <section id="forum" className="scroll-mt-24 bg-orange-50/60 py-10 md:py-14">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="mb-6 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
              <div>
                <h4 className="flex items-center gap-2 text-lg font-bold text-stone-900 md:text-xl">
                  <i className="ri-article-fill text-orange-500"></i> 吃瓜群众论坛 · 热门帖子
                </h4>
                <p className="mt-1 text-sm text-stone-500">分区热帖直连，标题一句带过、详情楼下见。</p>
              </div>
              <a
                href="#forum"
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-orange-300 px-4 py-2 text-sm text-orange-700 transition hover:bg-orange-100"
              >
                浏览全部帖子 <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {forumPosts.map((p) => (
                <article key={p.title} className="overflow-hidden rounded-lg border border-orange-100 bg-white transition hover:border-orange-300">
                  <div className="relative h-44 w-full overflow-hidden sm:h-48">
                    <img
                      src={p.img}
                      alt={`论坛热帖 ${p.title} 21吃瓜`}
                      title={`${brand} 论坛帖子 ${p.title}`}
                      className="h-full w-full object-cover object-top"
                    />
                    <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-medium text-orange-700 backdrop-blur">
                      {p.tag}
                    </span>
                  </div>
                  <div className="p-5">
                    <h5 className="text-sm font-semibold leading-snug text-stone-800 md:text-[15px]">{p.title}</h5>
                    <p className="mt-2 text-sm leading-relaxed text-stone-500">{p.summary}</p>
                    <div className="mt-4 flex items-center justify-between border-t border-orange-50 pt-3 text-xs text-stone-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line text-sm"></i> {p.replies}
                      </span>
                      {p.hot ? (
                        <span className="flex items-center gap-1 font-medium text-orange-500">
                          <i className="ri-fire-fill"></i> 帖热
                        </span>
                      ) : (
                        <a href="#forum" className="text-orange-600 hover:text-orange-700">
                          进楼讨论
                        </a>
                      )}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Topics scenes ===== */}
        <section id="topics" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-10 md:px-6 md:py-14">
          <div className="mb-6 flex items-center justify-between">
            <h4 className="flex items-center gap-2 text-lg font-bold text-stone-900 md:text-xl">
              <i className="ri-chat-history-fill text-orange-500"></i> 话题热议 · 吃瓜现场图文
            </h4>
            <a href="#topics" className="text-sm text-orange-600 hover:text-orange-700">
              更多现场
            </a>
          </div>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            {scenes.map((s) => (
              <article key={s.title} className="flex flex-col overflow-hidden rounded-lg border border-orange-100 bg-white sm:flex-row">
                <div className="relative h-52 w-full sm:h-auto sm:w-2/5">
                  <img
                    src={s.img}
                    alt={`话题热议现场 ${s.title} 21吃瓜`}
                    title={`${brand} 话题热议 ${s.title}`}
                    className="absolute inset-0 h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5 md:p-6">
                  <span className="inline-flex w-fit items-center rounded-full bg-orange-100 px-2.5 py-0.5 text-[11px] font-medium text-orange-700">
                    {s.tag}
                  </span>
                  <h5 className="mt-3 text-base font-semibold leading-snug text-stone-900 md:text-lg">{s.title}</h5>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-stone-500">{s.summary}</p>
                  <div className="mt-4 flex items-center justify-between text-xs text-stone-400">
                    <span>{s.read}</span>
                    <span className="flex items-center gap-1 text-orange-500">
                      <i className="ri-thumb-up-fill text-sm"></i> {s.upvotes.replace("点赞 ", "")}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* ===== Tags ===== */}
        <section id="tags" className="scroll-mt-24 bg-orange-50/60 py-10 md:py-14">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="mb-6 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
              <div>
                <h4 className="flex items-center gap-2 text-lg font-bold text-stone-900 md:text-xl">
                  <i className="ri-price-tag-3-fill text-orange-500"></i> 热门话题标签
                </h4>
                <p className="mt-1 text-sm text-stone-500">按标签快速落位，跟热点分类更顺手。</p>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2.5">
              {tags.map((t) => (
                <a
                  key={t.label}
                  href="#tags"
                  className={`flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm transition hover:bg-orange-100 ${
                    t.heat >= 80
                      ? "border-orange-300 bg-white font-medium text-orange-700"
                      : "border-orange-100 bg-white text-stone-600"
                  }`}
                >
                  <i className={`ri-fire-line text-xs ${t.heat >= 80 ? "text-orange-500" : "text-stone-300"}`}></i>
                  {t.label}
                  <span className="text-[11px] text-stone-400">{t.heat}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ===== Tools / download ===== */}
        <section id="tools" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-10 md:px-6 md:py-14">
          <div className="mb-6 flex items-center justify-between">
            <div>
              <h4 className="flex items-center gap-2 text-lg font-bold text-stone-900 md:text-xl">
                <i className="ri-download-2-fill text-orange-500"></i> 吃瓜工具箱 · 入口与下载
              </h4>
              <p className="mt-1 text-sm text-stone-500">网页版就能看，客户端与插件让追热点更省力。</p>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {tools.map((t) => (
              <div
                key={t.title}
                className={`flex flex-col justify-between rounded-lg border p-5 ${
                  t.accent ? "border-orange-500 bg-orange-500 text-white" : "border-orange-100 bg-white"
                }`}
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg text-2xl ${
                    t.accent ? "bg-white/20 text-white" : "bg-orange-100 text-orange-600"
                  }`}
                >
                  <i className={t.icon}></i>
                </span>
                <div className="mt-4 flex-1">
                  <h5 className={`text-base font-semibold ${t.accent ? "text-white" : "text-stone-900"}`}>{t.title}</h5>
                  <p className={`mt-1.5 text-sm leading-relaxed ${t.accent ? "text-orange-50" : "text-stone-500"}`}>
                    {t.desc}
                  </p>
                </div>
                <a
                  href="#tools"
                  className={`mt-4 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2.5 text-sm font-medium transition ${
                    t.accent
                      ? "bg-white text-orange-600 hover:bg-orange-50"
                      : "bg-orange-500 text-white hover:bg-orange-600"
                  }`}
                >
                  <i className={`${t.accent ? "ri-arrow-down-line" : "ri-download-2-line"} text-base`}></i>
                  {t.tag}
                </a>
              </div>
            ))}
          </div>
        </section>
      </main>

      {/* ===== Footer ===== */}
      <footer className="bg-orange-100/70">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-10 sm:grid-cols-2 md:grid-cols-4 md:px-6 md:py-14">
          <div className="sm:col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-orange-500 text-lg font-bold text-white">
                瓜
              </span>
              <span className="text-lg font-bold text-stone-900">{brand}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-stone-500">
              网友讨论与评论区热评汇聚地，围观吃瓜群众话题热议，论坛帖子补档与互动不停歇。
            </p>
          </div>
          <div>
            <h5 className="text-sm font-semibold text-stone-800">栏目导航</h5>
            <ul className="mt-3 space-y-2.5 text-sm text-stone-500">
              <li><a className="transition hover:text-orange-600" href="#hot">今日热议</a></li>
              <li><a className="transition hover:text-orange-600" href="#comments">评论区神评</a></li>
              <li><a className="transition hover:text-orange-600" href="#forum">论坛帖子</a></li>
              <li><a className="transition hover:text-orange-600" href="#topics">话题热议现场</a></li>
            </ul>
          </div>
          <div>
            <h5 className="text-sm font-semibold text-stone-800">热议分区</h5>
            <ul className="mt-3 space-y-2.5 text-sm text-stone-500">
              {tags.slice(0, 4).map((t) => (
                <li key={t.label}><a className="transition hover:text-orange-600" href="#tags">{t.label}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h5 className="text-sm font-semibold text-stone-800">关于本站</h5>
            <p className="mt-3 text-xs leading-relaxed text-stone-500">
              本站内容来自网友公开讨论与投稿整理，仅用于信息聚合展示，不代表本站立场。理性吃瓜，尊重他人，友善发言。
            </p>
            <a
              href="#tools"
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-orange-500 px-4 py-2 text-xs font-medium text-white transition hover:bg-orange-600"
            >
              <i className="ri-download-2-line text-sm"></i> 下载客户端
            </a>
          </div>
        </div>
        <div className="border-t border-orange-200/70">
          <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-stone-500 sm:flex-row md:px-6">
            <span>© 2026 {brand} · 网友讨论 / 评论区 / 话题热议 / 论坛帖子互动社区</span>
            <span>理性吃瓜 · 友善发言</span>
          </div>
        </div>
      </footer>
    </div>
  );
}